module.exports = __webpack_public_path__ + "static/img/iEP-5.5e1e17e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-5.jpg
// module id = s5+y
// module chunks = 1